import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Micro } from "../components/Reveal";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found — INT–EXT";
  }, []);

  return (
    <main
      data-testid="not-found"
      className="min-h-[100svh] bg-ink flex flex-col items-center justify-center px-6 text-center"
    >
      <img src="/logo-mark.png" alt="INT–EXT" className="h-16 mix-blend-screen mb-10" />
      <div className="font-display text-[clamp(5rem,18vw,10rem)] leading-none text-outline-gold select-none">
        404
      </div>
      <Micro className="block mt-6 text-gold/80">This page has moved or never existed</Micro>
      <Link
        to="/"
        data-testid="not-found-home"
        className="group mt-10 inline-flex items-center gap-3 bg-gold text-ink px-8 py-4 text-[11px] font-bold tracking-[0.25em] uppercase hover:bg-goldbright transition-colors duration-300"
      >
        <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-300" />
        Back to home
      </Link>
    </main>
  );
}
